import type { ClientCategory } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { ClientCategoriesGateway } from './client-categories';

/** Real HTTP implementation of the client category list (#604), spread into both form gateways. */
export const clientCategoriesHttp: ClientCategoriesGateway = {
  loadClientCategories: () => api.get<ClientCategory[]>('/licences/client-categories'),
  addClientCategory: (label) => api.post<ClientCategory>('/licences/client-categories', { label }),
};
